<script lang="ts">
  import {createEventDispatcher, onMount} from 'svelte';
  const dispatch = createEventDispatcher();

  export let decimalPlaces = 0;
  export let step = 1;
  export let minValue = 0;
  export let maxValue = 0;

  export let value: number | null = null;
  let rawValue: number = 0;
  let inputElement: HTMLInputElement;

  onMount(() => {
    rawValue = value as number;
    changeRunnerColor(inputElement);
  });

  const changeRunnerColor = (_: any) => {
    if (!_) return;

    const min = _.min;
    const max = _.max;
    const val = _.value;

    _.style.backgroundSize = ((val - min) * 100) / (max - min) + '% 100%';
  };

  const handleInputChange = (e: any) => {
    let target = e.target;
    rawValue = e.target.value;
    value = e.target.value;
    dispatch('change', {value});
    changeRunnerColor(inputElement);
  };
</script>

<div class="grid w-full">
  <input
    on:input={handleInputChange}
    type="range"
    {value}
    bind:this={inputElement}
    min={minValue}
    max={maxValue}
    {step}
    class="w-full"
  />
</div>

<style lang="postcss">
  input {
    -webkit-appearance: none;
    background-size: 0% 100%;
    background-repeat: no-repeat;
    @apply h-0.5 w-full rounded bg-zinc-300 bg-gradient-to-r from-rose-500 to-rose-600;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    @apply h-2.5 w-2.5 rounded-full bg-rose-500 shadow-md;
  }

  input::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    @apply bg-transparent;
  }
</style>
